module.exports = __webpack_public_path__ + "static/media/welcome_icon.7886b9c5.svg";